export const getPathWithoutSearch = (path: string) => {
    if (!path) {
        return null;
    }
    return path.split('?')[0];
};
